var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20 2H0V0H20V2ZM20 9.00195H0V7.00195H20V9.00195ZM0 16.0029H20V14.0029H0V16.0029Z","fill":"black"}));
}

Menu.defaultProps = {"width":"20","height":"17","viewBox":"0 0 20 17","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
